export default __webpack_public_path__ + "static/media/salmon-mobile@2x.d8172130.jpg";